var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99963 12.0081L3.13581 13.1442L4.74742 11.5326V21.6777H19.2519V11.5326L20.8635 13.1442L21.9996 12.0081L11.9996 2.00001L1.99963 12.0081ZM17.6402 20.0661H6.35902V9.92104L11.9996 4.28043L17.6402 9.92104V20.0661Z",
    fill: "#0067E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.114 10.5947C13.2962 10.8393 13.4124 11.1387 13.4626 11.4927H13.9996V12.4777H13.472C13.4281 12.8447 13.3244 13.1602 13.1611 13.4241C12.9978 13.6881 12.7434 13.8844 12.398 14.0132C12.5675 14.1033 12.7089 14.2289 12.8219 14.3898C12.9413 14.5443 13.0418 14.7407 13.1234 14.9789L13.9902 17.4221H12.5958L11.8421 15.2396C11.7416 14.9435 11.6222 14.7374 11.4841 14.6216C11.3459 14.5057 11.1229 14.4477 10.8151 14.4477H9.59973V13.4531H11.2391C11.5343 13.4531 11.751 13.3726 11.8892 13.2117C12.0337 13.0443 12.1247 12.7996 12.1624 12.4777H9.59973V11.4927H12.1624C12.131 11.1837 12.0368 10.9584 11.8798 10.8168C11.7227 10.6687 11.4778 10.5947 11.1449 10.5947H9.59973V9.60001H13.9996V10.5947H13.114Z",
    fill: "#0067E2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/Bank.c24f2242090c2caa3f4a440fdab5f0f6.svg";
export { ForwardRef as ReactComponent };